// Navbar.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/navbar.css'
import navbarLogo from '../images/NavbarLogo.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChartLine, faDiamond, faDatabase } from '@fortawesome/free-solid-svg-icons'
const Navbar = ({ selectedItem }) => {
    return (
        <nav>
            <a className='navbarLogo' href='https://www.gmila.org.il/gambling_rehab/' target="_blank" rel="noreferrer"><img src={navbarLogo} className='navbarLogoImg' alt='logo'></img></a>
            <ul>
                <li className={`${selectedItem === 'playerStatistics' ? 'selectedIcon' : ''}`} ><Link to="/Player_Statistics"><FontAwesomeIcon icon={faDatabase} className='navbarIcon' />סטטיסטיקות שחקן</Link></li>
                <li className={`${selectedItem === 'gameStatistics' ? 'selectedIcon' : ''}`} ><Link to="/Games_Statistics"><FontAwesomeIcon icon={faChartLine} className='navbarIcon' />סטטיסטיקות משחק</Link></li>
                <li className={`${selectedItem === 'game' ? 'selectedIcon' : ''}`} ><Link to="/Main"><FontAwesomeIcon icon={faDiamond} className='navbarIcon' />משחק</Link></li>
            </ul>
        </nav>
    );
}

export default Navbar;